import { Client } from 'src/redux/clientReducer'

export const formatClientDetailsName = (client: Client): string => {
  if (client.company_name !== null && client.company_name.length > 0) {
    return client.company_name
  }
  return `${client.first_name} ${client.last_name}`.trim()
}
